import React, { useEffect } from "react";
import { signal } from "@preact/signals-react";

import proxy from "api/proxy";
import StepSignature from "../views/steps/StepSignature";

const signatures = signal({});

function AddSignatureModal(props) {
  const { field, model, record, layout, parentRec, readOnly, tableId } = props;
  const { id } = record;

  async function getSignature() {
    const { data } = await proxy.browse(
      "staff_supply.request",
      [id],
      ["recipient_signature", "delivery_signature"],
    );
    signatures.value = data[0];
  }

  useEffect(() => {
    getSignature();
  }, []);

  return (
    <div className="relative">
      <StepSignature
        recId={id}
        record={signatures.value}
        style="max-w-[820px] mx-auto mt-[66px] mb-[80px]"
        mode="modal"
        layout={layout}
        tableId={tableId}
      />
    </div>
  );
}

export default AddSignatureModal;
